1<template>
	<div>

		<div style="background-color: #1158e6;height: 100vh;overflow-y: scroll;">
			<div>
				<div style="margin-bottom: 30px;">
					<img src="@/assets/zuixinimg/head.jpg" style="width: 100%;">
				</div>

				<div class="flex">
					<img src="@/assets/zuixinimg/1.png" class="img-box" style="height: 90px;" @click="welcome">
					<img src="@/assets/zuixinimg/2.png" class="img-box" style="height: 90px;" @click="organization">
					<img src="@/assets/zuixinimg/4.png" class="img-box" style="height: 90px;" @click="schedule">

				</div>

				<div class="flex">
					<img src="@/assets/zuixinimg/5.png" class="img-box" style="height: 90px;" @click="seleteLive">
					<img src="@/assets/zuixinimg/3.png" class="img-box" style="height: 90px;" @click="register">
					<img src="@/assets/zuixinimg/6.png" class="img-box" style="height: 90px;" @click="wonderful">
				</div>

				<div class="flex">
					<img src="@/assets/zuixinimg/11.png" class="img-box" style="height: 90px;" @click="creditState">
					<img src="@/assets/zuixinimg/10.png" class="img-box " style="height: 90px;" @click="photoLive">
					<img src="@/assets/zuixinimg/12.png" class="img-box " style="height: 90px;" @click="daily">
				</div>

				<div class="flex">
					<img src="@/assets/zuixinimg/8.png" class="img-box  img2" style="height: 90px;" @click="download">
					<img src="@/assets/zuixinimg/7.png" class="img-box  img2" style="height: 90px;" @click="guide">
					<img src="@/assets/zuixinimg/9.png" class="img-box  img2" style="height: 90px;" @click="contact">
				</div>
				<!-- 底部图文logo -->
				<!-- <div style="text-align: center;display: flex;flex-wrap: nowrap;justify-content: center;margin: 20px;">
					<img src="../../assets/ganzhiyu.png" style="width: 20%;background-color: #FFFFFF;border: none;" />
					<div style="background-color: #FFFFFF;font-size: 14px;border: none;line-height: 40px;">提供技术支持</div>
				</div> -->
			</div>

			<!-- 弹出延迟大会框 -->
			<!-- <div class="delay" v-if="isdelay" @click="isdelay_btn" style="display: none;">
				<div class="delay_box">
					<div class="delay_son">
						<div class="notice">延期通知</div>
						<span style="margin-left: 32px;">中</span>华医学会第一次全国细菌真菌感染学术会议，延期至2021年4月8-10日举办。
						<div style="text-align: right;margin-top: 15px;font-size: 16px;line-height: 25px;">中华医学会第一次全国细菌真菌感染学术会议会务组</div>
						<div style="text-align: right;font-size: 16px;line-height: 30px;">2020.12.01</div>
					</div>
				</div>
			</div> -->
			<div style="text-align: center;width: 100%;">
				<p style="color: white;letter-spacing: 1px;font-size: medium;">感知域提供技术支持</p>
			</div>
		</div>

	</div>
</template>

<script>
	import mammoth from 'mammoth';
	export default {
		data() {
			return {
				isdelay: true,
			}
		},
		methods: {
			photoLive() {
				window.location.href = "http://live.jfoto.cn/gti/d04d0ea7"
				// window.open("http://live.jfoto.cn/gti/d04d0ea7")
			},
			creditState() {
				window.location.href = "https://mp.weixin.qq.com/s/4XnbmZL3iWkjpI6dVeH-Gw"
				// window.open('https://mp.weixin.qq.com/s/xLjavRWiHmJHSxSAuhN1lw')
			},
			daily() {
				window.location.href =
					"http://mp.weixin.qq.com/mp/homepage?__biz=MzAwNDA4ODk3NQ==&hid=3&sn=6eb5d61ab747eaac9555ab9721b6a09f&scene=18#wechat_redirect"
				// window.open('http://mp.weixin.qq.com/mp/homepage?__biz=MzAwNDA4ODk3NQ==&hid=3&sn=6eb5d61ab747eaac9555ab9721b6a09f&scene=18#wechat_redirect')
				// this.$router.push({
				// 	path:"/daily"
				// })
			},
			register() {
				window.location.href = "https://app7VA52GBr7813.h5.xiaoeknow.com"
				// if (localStorage.getItem("user")) {
				// 	this.$router.push({
				// 		path: '/personalCenter'
				// 	})
				// } else {
				// 	this.$router.push({
				// 		path: '/seleteSignln'
				// 	})
				// 	// if (this.isWeiXin()) {
				// 	// 	this.oauth();
				// 	// } else {
				// 	// 	this.$router.push({
				// 	// 		path: '/seleteSignln'
				// 	// 	})
				// 	// }
				// }
			},
			isdelay_btn: function() {
				this.isdelay = false;
				sessionStorage.setItem('isdelay', true)
			},
			panduan: function() {
				if (sessionStorage.getItem('isdelay')) {
					this.isdelay = false
				} else {
					this.isdelay = true
				}
			},



			welcome: function() {
				this.$router.push({
					path: '/welcome-phone'
				})
			},
			stay() {
				if (localStorage.getItem("user")) {
					this.$router.push({
						path: '/stay'
					});
				} else {
					var r = confirm("您当前没有登录，请先登录，方可进行投稿");
					if (r == true) {
						localStorage.removeItem('user');
						this.$router.push({
							path: '/signIn'
						})
					}
				}


				// alert("此功能后续开放....")
			},


			schedule() {

				this.$router.push({
					path: '/schedule-phone'
				})
			},
			contact() {
				this.$router.push({
					path: '/contact'
				})
			},

			seleteLive: function() {
				this.$router.push({
					path: '/LivePage'
				})
				// if (localStorage.getItem("user")) {
				// 	let info = JSON.parse(localStorage.getItem("user"))
				// 	this.$api.getUserLiveUrl({
				// 		phone: info.user.phone
				// 	}, res => {
				// 		if (res.data && res.data.rc == this.$util.RC.SUCCESS) {
				// 			window.location.href = res.data.c
				// 		} else {
				// 			this.$message.error(res.data.rm);
				// 		}
				// 	});
				// } else {
				// 	var r = confirm("您当前没有登录，请先注册会议网站并进行登录，方可观看本次大会直播");
				// 	if (r == true) {
				// 		localStorage.removeItem('user');
				// 		this.$router.push({
				// 			path: '/signIn'
				// 		})
				// 	}
				// }
			},
			wonderful: function() {
				this.$router.push({
					path: '/wonderful'
				})
			},
			guide() {
				// window.location.href = "https://mp.weixin.qq.com/s/VMQ6tNxb_dMuOHAa2v7vGQ";
				this.$router.push({
					path: '/guide-phone'
				})
			},

			download: function() {
				this.$router.push({
					path: '/download-phone'
				})
			},

			oauth() {
				//    snsapi_base  snsapi_userinfo 第一步用户授权，跳转目标页，在下一页得到code
				let AppId = "wxc17e1b4c4aceccbb"; //公众号的唯一标识,开发者ID
				let score = 'snsapi_userinfo' //这里采用静默登录 //or snsapi_userinfo
				let redirect_urls = encodeURIComponent("http://bisc2021.ganzhiyu.com/index.html#/weixin");
				let urls = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + AppId + "&redirect_uri=" +
					redirect_urls +
					"&response_type=code&scope=" + score + "&state=STATE#wechat_redirect";
				window.location.href = urls;
			},
			// 判断是否是微信端浏览器
			isWeiXin() {
				var ua = window.navigator.userAgent.toLowerCase();
				if (ua.match(/MicroMessenger/i) == 'micromessenger') {
					return true; // 是微信端
				} else {
					return false;
				}
			},

			organization() {
				this.$router.push({
					path: '/organization-phone'
				})
			}
		},
		created() {
			let flag = navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			);
			if (!flag) {
				this.$router.push({
					path: '/'
				})
			};


		},
		mounted() {
			this.panduan();
		}
	}
</script>

<style scoped>
	.img-box {
		width: 90px;
		padding: 15px 0;
	}

	.flex {
		display: flex;
		justify-content: space-around;
		align-items: center;
		width: 90%;
		margin: 0 auto;
	}

	.line {
		border-top: 1px solid rgba(0, 0, 0, 0.2);
	}

	.border {
		border-left: 1px solid rgba(0, 0, 0, 0.2);
		border-right: 1px solid rgba(0, 0, 0, 0.2);

	}


	.img2 {
		padding-bottom: 0
	}

	.delay {
		width: 100%;
		height: 100%;
		position: fixed;
		background-color: rgba(0, 0, 0, 0.5);
		top: 0;
		left: 0;
		z-index: 999;
	}

	.delay_box {
		width: 265px;
		background-color: #fff;
		margin: 0 auto;
		margin-top: 150px;
		border-radius: 5px;
		padding: 20px;
		font-size: 17px;
		color: #555;
		line-height: 30px;
		overflow: hidden;
	}

	.delay_son {
		/* margin-top: 10px; */
	}

	.notice {
		padding: 0;
		text-align: center;
		font-size: 18px;
		margin-bottom: 5px;
		font-weight: bold;
		color: #333;
	}
</style>
